<template src="./AssociateLabExam.html"></template>
<script>
import mixins from "../../../../../Mixins.js";
export default {
  mixins: [mixins],
  data() {
    return {
      showContent: false,
      laboratories: undefined,
      windowWidth: 0,
      currentx: 1,     
      currentxExames: 1,
      currentxVinculados: 1,
      numPages: 0,     
      numPagesExames: 0,
      numPagesVinculados: 0,
      pagination: false,     
      paginationExames: false,
      paginationVinculados: false,
      searchLaboratory: "",
      searchExames: "",
      searchVinculados: "",
      popupExames: false,
      popupExamesData: {
        active: undefined,
        id: undefined,
        name: undefined,
        addresses: [],
      },
      pageExames: 0,
      exames: {},
      vincula: {},
    }
  },
  mounted() {
    const vm = this;
    vm.init();
  },
  created() {
    const vm = this;
    window.addEventListener("resize", vm.handleResize);
    vm.handleResize();
  },
  destroyed() {
    const vm = this;
    window.removeEventListener("resize", vm.handleResize);
  },
  watch: {
    currentx: function () {
      const vm = this;
      vm.changePagination();
    },
    currentxExames: function () {
      const vm = this;
      vm.changePaginationExames();
    },
    currentxVinculados: function () {
      const vm = this;
      vm.changePaginationVinculados();
    },
  },
  methods: {
    init() {
      const vm = this;
      vm.getLaboratories();
    },
    editExamesPopup(Laboratory) {
      const vm = this;
      vm.popupExames = true;
      vm.popupExamesData = {
        active: Laboratory.active,
        id: Laboratory.id,
        name: Laboratory.name,
        phone: Laboratory.phone,
        addresses: [],
      }
      vm.getExames();
      vm.getVinculados(Laboratory.id);
    },
    getExames() {
      const vm = this;
      const page = vm.currentxExames - 1;
      vm.axios
        .get(
          vm.$store.state.filooServer +
          "exames?page=" + page + "&search=" + vm.searchExames + "&size=3&sort=id,asc", {
            headers: {
              Authorization: vm.$session.get("bearerDefault")
            },
          }
        )
        .then(function (response) {
          if (response.status == 200) {
            vm.exames = response.data.content;
            vm.numPagesExames = response.data.totalPages;
            vm.paginationExames = vm.numPagesExames > 1;
          }
        })
    },
    getVinculados(laboratorioId) {
      const vm = this;
      const page = vm.currentxVinculados - 1;
      vm.axios
        .get(
          vm.$store.state.filooServer +
          "orizon/labExamesVinculados/" + laboratorioId + 
          "?page=" + page + 
          "&search=" + vm.searchVinculados + 
          "&size=3&sort=id,asc", {
            headers: {
              Authorization: vm.$session.get("bearerDefault")
            },
          }
        )
        .then(function (response) {
          if (response.status == 200) {
            vm.vincula = response.data.content;
            vm.numPagesVinculados = response.data.totalPages;
            vm.paginationVinculados = vm.numPagesVinculados > 1;
          }
        });

    },
    getLaboratories() {
      const vm = this;
      const page = vm.currentx - 1;
      vm.axios
        .get(
          vm.$store.state.filooServer +
          "orizon?page=" + page + "&search=" + vm.searchLaboratory + "&size=10&sort=id,asc", {
            headers: {
              Authorization: vm.$session.get("bearerDefault")
            },
          }
        )
        .then(function (response) {
          if (response.status == 200) {
            vm.laboratories = response.data.content;
            vm.numPages = response.data.totalPages;
            vm.pagination = vm.numPages > 1;
            vm.showContent = true;
          }
        });
    },
    changePagination() {
      const vm = this;
      vm.getLaboratories();
    },
    changePaginationVinculados() {
      const vm = this;
      vm.getVinculados();
    },
    changePaginationExames() {
      const vm = this;
      vm.getExames();
    },

    toggleVinculado(exame) {
      const vm = this;
      let labExamObj = {
        "laboratorio": vm.popupExamesData,
        "exame": exame
      }
      vm.axios
        .post(
          vm.$store.state.filooServer + "orizon/labExame", labExamObj, {
            headers: {
              Authorization: vm.$session.get("bearerDefault")
            },
          }
        )
        .then(function (response) {
          if (response.status == 200) {
            vm.getVinculados(vm.popupExamesData.id);
          }
        });

    },

    toggleDesvinculado(exame) {
      const vm = this;
      let labExamObj = {
        "laboratorio": vm.popupExamesData,
        "exame": exame
      }
      vm.axios
        .put(
          vm.$store.state.filooServer + "orizon/labExame", labExamObj, {
            headers: {
              Authorization: vm.$session.get("bearerDefault")
            },
          }
        )
        .then(function (response) {
          if (response.status == 200) {
            vm.getVinculados(vm.popupExamesData.id);
          }
        });

    },
    changeSearchExames() {
      const vm = this;
      vm.currentxExames = 1;
      vm.getExames();
    },
    changeSearchLaboratory() {
      const vm = this;
      vm.currentx = 1;
      vm.getLaboratories();
    },
    handleResize() {
      const vm = this;
      vm.windowWidth = window.innerWidth;
    },
  },
};
</script>
<style lang="scss" src="./AssociateLabExam.scss">
</style>